exports = module.exports = require("/code/node_modules/css-loader/cssToString.js")();
exports.push([module.id, ".stamp-ListGallery-item{position:relative;margin-bottom:1rem;text-align:center}.stamp-ListGallery-item:last-child{margin-bottom:0}@media only screen and (min-width:40em){.stamp-ListGallery-item{margin-bottom:2rem}}@media only screen and (min-width:62em){.stamp-ListGallery-item{margin-bottom:2rem}}@media only screen and (min-width:75em){.stamp-ListGallery-item{margin-bottom:3rem}}@media only screen and (min-width:100em){.stamp-ListGallery-item{margin-bottom:4rem}}", ""]);


/*****************
 ** WEBPACK FOOTER
 ** /code/~/css-loader?-minimize!/code/~/postcss-loader!/code/~/less-loader!./stamp/ListGallery.less
 ** module id = 327
 ** module chunks = 1 2
 **/